namespace RioERP.Invoices {
    export interface InvoiceHsnRow {
        Id?: number;
        OrderId?: number;
        HsnMasterId?: number;
        TaxCategoryId?: number;
        TaxableAmount?: number;
        TaxTypeId?: number;
        TaxAmount?: number;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        HsnMasterInvoicenumber?: string;
        HsnMasterInvoiceDate?: string;
        HsnMasterInvoiceCompanyId?: number;
        HsnMasterEInvoiceType?: number;
        HsnMasterEInvoiceTo?: number;
        HsnMasterCustomerId?: number;
        HsnMasterFranchiseeId?: number;
        HsnMasterDiscountAmount?: number;
        HsnMasterGrossAmount?: number;
        HsnMasterNetAmount?: number;
        HsnMasterTaxableAmount?: number;
        HsnMasterIsRecalculated?: boolean;
        HsnMasterEInvoiceStatus?: number;
        HsnMasterBillingAddress1?: string;
        HsnMasterBillingAddress2?: string;
        HsnMasterBillingCity?: string;
        HsnMasterBillingStateId?: number;
        HsnMasterBillingPincode?: number;
        HsnMasterIsActive?: boolean;
        HsnMasterInsertUserId?: number;
        HsnMasterInsertDate?: string;
        HsnMasterUpdateUserId?: number;
        HsnMasterUpdateDate?: string;
        TaxCategoryName?: string;
        TaxCategoryIsActive?: boolean;
        TaxCategoryInsertUserId?: number;
        TaxCategoryInsertDate?: string;
        TaxCategoryUpdateUserId?: number;
        TaxCategoryUpdateDate?: string;
        TaxTypeName?: string;
    }

    export namespace InvoiceHsnRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Invoices.InvoiceHsn';
        export const deletePermission = 'Invoices:InvoicesManagement:Modify';
        export const insertPermission = 'Invoices:InvoicesManagement:Modify';
        export const readPermission = 'Invoices:InvoicesManagement:View';
        export const updatePermission = 'Invoices:InvoicesManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            HsnMasterId = "HsnMasterId",
            TaxCategoryId = "TaxCategoryId",
            TaxableAmount = "TaxableAmount",
            TaxTypeId = "TaxTypeId",
            TaxAmount = "TaxAmount",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            HsnMasterInvoicenumber = "HsnMasterInvoicenumber",
            HsnMasterInvoiceDate = "HsnMasterInvoiceDate",
            HsnMasterInvoiceCompanyId = "HsnMasterInvoiceCompanyId",
            HsnMasterEInvoiceType = "HsnMasterEInvoiceType",
            HsnMasterEInvoiceTo = "HsnMasterEInvoiceTo",
            HsnMasterCustomerId = "HsnMasterCustomerId",
            HsnMasterFranchiseeId = "HsnMasterFranchiseeId",
            HsnMasterDiscountAmount = "HsnMasterDiscountAmount",
            HsnMasterGrossAmount = "HsnMasterGrossAmount",
            HsnMasterNetAmount = "HsnMasterNetAmount",
            HsnMasterTaxableAmount = "HsnMasterTaxableAmount",
            HsnMasterIsRecalculated = "HsnMasterIsRecalculated",
            HsnMasterEInvoiceStatus = "HsnMasterEInvoiceStatus",
            HsnMasterBillingAddress1 = "HsnMasterBillingAddress1",
            HsnMasterBillingAddress2 = "HsnMasterBillingAddress2",
            HsnMasterBillingCity = "HsnMasterBillingCity",
            HsnMasterBillingStateId = "HsnMasterBillingStateId",
            HsnMasterBillingPincode = "HsnMasterBillingPincode",
            HsnMasterIsActive = "HsnMasterIsActive",
            HsnMasterInsertUserId = "HsnMasterInsertUserId",
            HsnMasterInsertDate = "HsnMasterInsertDate",
            HsnMasterUpdateUserId = "HsnMasterUpdateUserId",
            HsnMasterUpdateDate = "HsnMasterUpdateDate",
            TaxCategoryName = "TaxCategoryName",
            TaxCategoryIsActive = "TaxCategoryIsActive",
            TaxCategoryInsertUserId = "TaxCategoryInsertUserId",
            TaxCategoryInsertDate = "TaxCategoryInsertDate",
            TaxCategoryUpdateUserId = "TaxCategoryUpdateUserId",
            TaxCategoryUpdateDate = "TaxCategoryUpdateDate",
            TaxTypeName = "TaxTypeName"
        }
    }
}
